import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { endOfDay } from 'date-fns'

import { QA_NAME_CANCEL_BTN, QA_NAME_SAVE_BTN } from '../../../constants/qa'
import { useTimeZone } from '../../../hooks'
import {
  getDateEndParam,
  getDateStartParam,
  getRelatedFilters,
} from '../../../utils/filter'
import Button from '../../Button'
import { DatePickerWithRange } from '../../DateTime'
import Modal, { Box, Buttons, Content, Header } from '../../Modal'
import { NotificationInline } from '../../Notification'
import { parseApiDateToUkDay } from '../FilterModalAvailableFilters'

function FilterDateRangeModal({
  availableFilters,
  dateRangeName,
  filterOptions,
  onClose,
  onSetDate,
  onSetDateRange,
}) {
  const { t } = useTranslation()
  const timezone = useTimeZone()

  const relatedFilterName = getRelatedFilters(availableFilters)[dateRangeName]

  const [showError, setShowError] = useState(false)

  const startDateParam = getDateStartParam(relatedFilterName)
  const endDateParam = getDateEndParam(relatedFilterName)

  const [startDate, setStartDate] = useState(
    parseApiDateToUkDay(
      filterOptions?.[startDateParam]?.value || null,
      timezone
    )
  )
  const [endDate, setEndDate] = useState(
    parseApiDateToUkDay(filterOptions?.[endDateParam]?.value || null, timezone)
  )

  const { type } = availableFilters.find(
    ({ name }) => name === relatedFilterName
  )

  function handleAddDate() {
    if (!startDate) {
      setShowError(true)

      return
    }

    if (endDate) {
      onSetDateRange(startDateParam, startDate, endDateParam, endDate, type)
    } else {
      onSetDate([startDateParam, endDateParam], startDate, type)
    }

    onClose()
  }

  function handleChangeSingle(next) {
    setShowError(false)
    setStartDate(next)
    setEndDate(next ? endOfDay(next) : null)
  }

  function handleChangeRange([start, end]) {
    setShowError(false)
    setStartDate(start)
    setEndDate(end ? endOfDay(end) : null)
  }

  return (
    <Modal onClose={onClose}>
      <Box size='m'>
        <Header
          size='m'
          text={t('Modal.CustomDateTitleKey')}
          onClose={onClose}
        />
        <Content size='m'>
          {showError && (
            <NotificationInline
              text={t('Notification.EmptyDateErrorTitleKey')}
              type='error'
            />
          )}
          <DatePickerWithRange
            endValue={endDate}
            placeholder={t('Filter.AddCustomDatePlaceholderKey')}
            startValue={startDate}
            value={startDate}
            onChange={handleChangeSingle}
            onChangeRange={handleChangeRange}
          />
        </Content>
        <Buttons size='m'>
          <Button.Contained
            qaName={QA_NAME_SAVE_BTN}
            text={t('Modal.AddCustomDateBtnKey')}
            onClick={handleAddDate}
          />
          <Button.Outlined
            qaName={QA_NAME_CANCEL_BTN}
            text={t('Modal.CancelBtnKey')}
            onClick={onClose}
          />
        </Buttons>
      </Box>
    </Modal>
  )
}

export default FilterDateRangeModal
